import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import loginImage from '../../../assets/login.png';
import { sendEmail } from '../../../services/forgotPassword/sendEmail';

const ForgotPasswordPage = () => {

    const dispatch = useDispatch();


    const [loginFormValue, setForgotPassFormValue] = useState({
        email: "",
    })
    const { email } = loginFormValue;

    const onSendCode = (e) => {
        e.preventDefault();
        console.log(email);

        if (!email.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'El campo de email no puede estar vacío.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Por favor ingresa un email válido.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        dispatch(sendEmail(email))
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Email de recuperación enviado',
                    text: 'Revisa tu bandeja de entrada para continuar.',
                    confirmButtonText: 'Aceptar'
                }).then(() => {
                    localStorage.setItem('encryptedEmail', email);
                    window.location.href = '/auth/new-password';
                });
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al restablecer la contraseña.',
                    confirmButtonText: 'Aceptar'
                }).then(() => {
                    localStorage.clear();
                    window.location.href = '/auth/login';
                });
            });

    }

    return (
        <div className="main">
            <section className="forgot">
                <div className="container">
                    <div className="forgot-content">
                        <div className="forgot-image">
                            <figure><img className="imglogin" src={loginImage} alt="descripcion imagen" /></figure>
                            {/* <a href="#" className="signup-image-link">Create an account</a> */}
                        </div>
                        <div className="forgot-form">
                            <h2 className="form-title">Recupera tu clave</h2>
                            <form method="POST" className="forgot-password-form" id="forgot-password-form" onSubmit={onSendCode}>
                                <div className="form-group">
                                    <label htmlFor="your_name"><i className="zmdi zmdi-account material-icons-name" /></label>
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Ingresa tu email"
                                        value={email}
                                        onChange={(e) => setForgotPassFormValue({ ...loginFormValue, email: e.target.value })}
                                    />
                                </div>

                                {/* <div className="form-group">
                                    <input type="checkbox" name="remember-me" id="remember-me" className="agree-term" />
                                    <label htmlFor="remember-me" className="label-agree-term"><span><span /></span>Remember me</label>
                                </div> */}
                                <div className="form-group form-button">
                                    <button name="forgot" id="forgot" className="form-submit" defaultValue="Log in" >
                                        Recuperar Contraseña
                                    </button>
                                </div>

                            </form>
                            <div className="social-login">
                                {/* <span className="social-label">Or login with</span> */}
                                <ul className="socials">
                                    <li><button className="buttonhref"><i className="display-flex-center zmdi zmdi-facebook" /></button></li>
                                    <li><button className="buttonhref"><i className="display-flex-center zmdi zmdi-twitter" /></button></li>
                                    <li><button className="buttonhref" ><i className="display-flex-center zmdi zmdi-google" /></button></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ForgotPasswordPage;